<script>
    // core components
    import EscoltaView from "../../viewsERP/Escolta.svelte";
  </script>
  
  <div class="flex flex-wrap mt-4">
    <div class="w-full mb-12 px-4">
      <EscoltaView />
    </div>
  </div>